// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"538":"5bc403eb","599":"c5f5996f"}[chunkId] + ".chunk.js";
};